__turbopack_context__.v({
  "card": "radio-module__Yom8xG__card",
  "cardBody": "radio-module__Yom8xG__cardBody",
  "cardDesc": "radio-module__Yom8xG__cardDesc",
  "cardLabel": "radio-module__Yom8xG__cardLabel",
  "cardTick": "radio-module__Yom8xG__cardTick",
  "cardTickInner": "radio-module__Yom8xG__cardTickInner",
  "group": "radio-module__Yom8xG__group",
  "indicator": "radio-module__Yom8xG__indicator",
  "radio": "radio-module__Yom8xG__radio",
});
